export default __webpack_public_path__ + "static/Screenshot7-7453b95aa53ed8ab703cdeac8e9ff8bb.jpg";